import { render, staticRenderFns } from "./TextEditorVideo.vue?vue&type=template&id=632a622a"
import script from "./TextEditorVideo.vue?vue&type=script&lang=ts"
export * from "./TextEditorVideo.vue?vue&type=script&lang=ts"
import style0 from "./TextEditorVideo.vue?vue&type=style&index=0&id=632a622a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports